module.exports = __webpack_public_path__ + "media/images/logo-landing-dark-901d839559601cf63a49f59961118900.png";